import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Dumbbell, Ruler, BarChart2, Apple } from "lucide-react";
import { motion } from "framer-motion";

const NAV_ITEMS = [
  { path: "/", label: "Entreno", icon: Dumbbell },
  { path: "/dieta", label: "Dieta", icon: Apple },
  { path: "/peso", label: "Medidas", icon: Ruler },
  { path: "/history", label: "Progreso", icon: BarChart2 },
];

export function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50">
      {/* Blur backdrop fills the full nav area */}
      <div
        className="absolute inset-0"
        style={{
          background: 'rgba(9, 9, 14, 0.82)',
          backdropFilter: 'blur(48px)',
          WebkitBackdropFilter: 'blur(48px)',
          borderTop: '1px solid rgba(255,255,255,0.07)',
        }}
      />

      <div className="relative mx-auto max-w-2xl">
        {/* pb-safe no existe en esta configuración de Tailwind y pb-3 lo anulaba
            igualmente: instalada y a pantalla completa, la barra quedaría bajo
            el indicador de gestos. El margen se toma del sistema. */}
        <div
          className="flex items-stretch justify-around px-2 pt-1.5"
          style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom, 0px))" }}
        >
          {NAV_ITEMS.map((item) => {
            const active = location.pathname === item.path;
            const Icon = item.icon;
            return (
              <motion.button
                key={item.path}
                onClick={() => navigate(item.path)}
                whileTap={{ scale: 0.88 }}
                className="relative flex flex-col items-center justify-center gap-1 min-w-[64px] px-2 py-1.5 rounded-2xl"
              >
                {/* Active pill background */}
                {active && (
                  <motion.div
                    layoutId="nav-pill"
                    className="absolute inset-0 rounded-2xl"
                    style={{ background: "rgba(10, 133, 255, 0.12)" }}
                    transition={{ type: "spring", stiffness: 500, damping: 38 }}
                  />
                )}

                {/* Icon */}
                <div className="relative">
                  <Icon
                    className={`h-[22px] w-[22px] transition-all duration-200 ${
                      active ? "text-primary drop-shadow-[0_0_8px_rgba(10,133,255,0.6)]" : "text-white/40"
                    }`}
                    strokeWidth={active ? 2.2 : 1.8}
                  />
                </div>

                {/* Label */}
                <span className={`text-[10px] font-semibold tracking-wide transition-all duration-200 ${
                  active ? "text-primary" : "text-white/35"
                }`}>
                  {item.label}
                </span>
              </motion.button>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
